import axios from 'axios'

import { createTripDashboardAxiosChangeInterceptor } from '../../trip-dashboard/utils/tripDashboardInterceptor'

const token = document.head.querySelector('meta[name="csrf-token"]')

if (!token) {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

const tripDashboardAxios = axios.create({
  baseURL: '/trip-dashboard/',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    // @ts-ignore // TODO:
    'X-CSRF-TOKEN': token.content
  }
})

// Add response interceptor to emit events when trip dashboard data changes
createTripDashboardAxiosChangeInterceptor(tripDashboardAxios)

export default tripDashboardAxios
